import { render, staticRenderFns } from "./LogoWeiboIcon.vue?vue&type=template&id=042a54ba&"
import script from "./LogoWeiboIcon.vue?vue&type=script&lang=js&"
export * from "./LogoWeiboIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports